var TaskAction = /** @class */ (function () {
    function TaskAction(dto) {
        this.taskID = dto.taskID;
        this.partobjectID = dto.partobjectID;
        this.head = dto.head;
        this.userID = dto.userID;
        this.isPause = dto.isPause;
    }
    return TaskAction;
}());
export default TaskAction;



//////////////////
// WEBPACK FOOTER
// ./src/models/TaskAction.ts
// module id = 809
// module chunks = 0